module.exports = __webpack_public_path__ + "static/cabin-e31de9d878c4caeed3b93b67e5b5191c.svg";